import {MenuRouterInterface} from './shared/menu-router';
import {Component, isDevMode, OnInit, ViewEncapsulation} from '@angular/core';
import * as $ from 'jquery';
import {UserPermissionsService} from 'src/app/shared/services/user-permissions.service';
import {Sweetalert} from 'src/app/shared/messages/alerts/sweetalert';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit {
  closeMenu = closeMenu;
  devMode = isDevMode();
  itemMenu: MenuRouterInterface;
  interface = [];
  rota = "";

  constructor(
    private userPermissionsService: UserPermissionsService,
    public sweetalert: Sweetalert
  ) {}

  ngOnInit() {
    this.getModuleAccess();
    this.iniciaMenuMobile();
  }

  // NOTE Recebe uma lista de módulos que podem ser rendenizados
  getModuleAccess() {
    this.userPermissionsService.readElements().subscribe(
      response => {
        this.interface = response;
        // ANCHOR Apenas para ordenar o array por ordem alfaberica
        this.interface.sort((a, b) =>
          a.label > b.label ? 1 : b.label > a.label ? -1 : 0
        );
      },
      error => this.sweetalert.onError(error)
    );
  }

  // FIXME Responsavel pelo comportamento do menu quando mobile, podemos passar de jquery pata TS
  iniciaMenuMobile(): void {
    $('body').on('click', '[data-ma-action]', function(e) {
      e.preventDefault();
      const action = $(this).data('ma-action');
      const $this = $(this);
      switch (action) {
        case 'sidebar-open':
          openMenu(this, $this);
          break;
        case 'sidebar-close':
          closeMenu();
          break;
      }
    });
  }
}

/*
  Responsavel pela animação de abre
  e fecha o menu quando mobile
*/
function openMenu(event, event2) {
  const target = $(event).data('ma-target');
  event2.addClass('toggled');
  $('#main').append(
    '<div data-ma-action="sidebar-close" class="sidebar-backdrop animated fadeIn" />'
  );
  if (target === 'main-menu') {
    $('#s-main-menu').addClass('toggled');
  }
  if (target === 'user-alerts') {
    $('#s-user-alerts').addClass('toggled');
  }
  $('body').addClass('o-hidden');
}

function closeMenu() {
  $('[data-ma-action="sidebar-open"]').removeClass('toggled');
  $('.sidebar').removeClass('toggled');
  $('.sidebar-backdrop').remove();
  $('body').removeClass('o-hidden');
}
